import styled, { css } from 'styled-components';
import { SmallHeadline } from 'ggApp/shared/common/Typography';

export const ANIMATION_DURATION_IN_MS = 200;

const Wrap = styled.div`
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
`;

const Text = styled.p`
    color: ${({ theme }) => theme.colors['Level 3']};
    line-height: normal;
    margin-right: ${({ theme }) => theme.spacers.S};
    flex: 0 0 auto;
    ${({ theme }) => css(theme.typography.SmallHeadline)}
`;

const SuggestionList = styled.ul`
    position: relative;
    width: inherit;
`;

const Suggestion = styled.li`
    position: absolute;
    ${({ theme }) => css(theme.typography.SmallHeadline)}
    line-height: normal;
    color: ${({ theme }) => theme.colors['Level 3']};
    opacity: 0;
    transition-property: opacity;
    transition-duration: ${ANIMATION_DURATION_IN_MS}ms;
    transition-timing-function: ease;
    &.categoryText-enter-active, &.categoryText-exit-active {
        opacity: 0.5;
    }
    &.categoryText-enter-done {
        opacity: 1;
    }
    &.categoryText-exit-done {
        opacity: 0;
    }
`;

export {
    Wrap, Text, SuggestionList, Suggestion,
};
